const STYLES = [
  {
    id: 'black',
    label: 'Black Calculator Logos',
    desc: 'High-contrast monochrome marks built for embossing, stationery, and luxury print.',
    bg: 'bg-[#05060a]',
    fg: 'text-white',
    ring: 'ring-white/10',
  },
  {
    id: 'white',
    label: 'White Calculator Logos',
    desc: 'Clean reversed-out identities for dark UIs, apparel, and minimalist decks.',
    bg: 'bg-white',
    fg: 'text-[#070a13]',
    ring: 'ring-black/10',
  },
  {
    id: 'neon',
    label: 'Neon Calculator Logos',
    desc: 'Glowing indigo and emerald gradients tuned for screens, motion, and nightlife brands.',
    bg: 'bg-gradient-to-br from-indigo-600 to-emerald-400',
    fg: 'text-[#070a13]',
    ring: 'ring-indigo-400/30',
  },
] as const

function StyleGallery() {
  return (
    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {STYLES.map((s) => (
        <figure
          key={s.id}
          className="group overflow-hidden rounded-2xl border border-white/8 bg-[#0b1020] shadow-xl shadow-black/40 transition-transform hover:-translate-y-1"
        >
          <div
            className={`flex h-44 items-center justify-center ring-1 ${s.bg} ${s.ring} transition-transform group-hover:scale-[1.02]`}
          >
            <div className={`flex flex-col items-center gap-2 ${s.fg}`}>
              <div className="grid grid-cols-3 gap-1">
                {Array.from({ length: 9 }).map((_, i) => (
                  <span
                    key={i}
                    className={`h-3 w-3 rounded-sm ${s.id === 'white' ? 'bg-[#070a13]/80' : 'bg-current opacity-80'}`}
                  />
                ))}
              </div>
              <span className="font-display text-sm font-bold tracking-wide">CALC</span>
            </div>
          </div>
          <figcaption className="p-5">
            <h3 className="font-display text-base font-semibold text-white">{s.label}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-slate-400">{s.desc}</p>
          </figcaption>
        </figure>
      ))}
    </div>
  )
}

export default StyleGallery
